import { render, staticRenderFns } from "./GenericSerialNumber.vue?vue&type=template&id=7dfc642e&"
import script from "./GenericSerialNumber.vue?vue&type=script&lang=ts&"
export * from "./GenericSerialNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports